<div class="padding">
  <header>
    <h1>Estoque em diferentes filiais</h1>
    <mat-icon matDialogClose> close </mat-icon>
  </header>
  <div class="line"></div>

  <ng-container *ngIf="dataDisplay | async as data">
    <bs-table
      pdv-table-filial
      *ngIf="data.length > 0; else empty"
      [columnsOptions]="columnsOptions"
      [dataSource]="data"
    ></bs-table>

    <ng-template #empty>
      <div class="empty-state">
        <h1>Nenhuma filial encontrada</h1>
      </div>
    </ng-template>
  </ng-container>
</div>
